export const initialValues = {
	message: "",
};
